import React from 'react';
import {
  IconFilter,
  FilterSelectComponent,
} from 'nallian-shared-ui/lib/components/semantic-filter-components';
import { countryOptions } from '../../../../../portal/app/constants/countries';

const CountryFilter = () => (
  <IconFilter
    hasApplyButton
    name="countryCode"
    position="bottom right"
    placement="bottom-end"
    as={FilterSelectComponent}
    options={countryOptions}
  />
);

export default CountryFilter;
